import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import { PayByZarinPal } from './PayByZarinPal';
import { SaveAppointment } from './SaveAppointment';
import { v4 as uuidV4 } from 'uuid';
import { GetSamanKishToken } from './GetSamanKishToken';

export const CheckPardakhtBeforSave = async (data) => {
  let currentUrl = window.location.href;
  currentUrl = document.URL;
  currentUrl = new URL(window.location);
  currentUrl = currentUrl.origin;

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_CHECK_PARDAKHT_BEFORE_SAVE}`,
    true,
    {
      idPatient: data?.idPatient,
      idNobat: data?.idNobat,
    }
  ).then((response) => {
    console.log(
      'REACT_APP_API_URL_API_CHECK_PARDAKHT_BEFORE_SAVEREACT_APP_API_URL_API_CHECK_PARDAKHT_BEFORE_SAVE=>',
      response
    );
    if (response.data.resCode === 1) {
      if (
        response.data.Data.mablagheGhabeleDaryaft > 0 ||
        (data?.paymentMode === 1 &&
          response.data.Data.hazineInterneti)
      ) {
        localStorage.setItem(
          'pay_redirect',
          JSON.stringify({
            idPatient: data?.idPatient,
            idNobat: data?.idNobat,
          })
        );

        if (
          data.portal === 'zp' &&
          data.isZarinPalEnabled
        ) {
          PayByZarinPal({
            idPatient: data?.idPatient,
            amount: data.isWallet
              ? data.isWallet
              : response.data.Data.mablagheGhabeleDaryaft,
            Description: data?.doctorInfo,
            email: data.user.Email,
            mobile: data.user.Mobile,
            callBackLink: `${currentUrl}/VerifyZarinPal`,
          });
          return;
        }

        if (
          data.portal === 'sm' &&
          data.isSamanKishEnabled
        ) {
          GetSamanKishToken(data.setSamanToken, {
            amount: data.isWallet
              ? data.isWallet
              : response.data.Data.mablagheGhabeleDaryaft,
            mobile: data.user.Mobile,
          });
          return;
        }
        return;
      }

      if (response.data.resCode === 1) {
        // SwalAlert(
        //   'success',
        //   response.data.resMessage,
        //   false,
        //   null,
        //   null,
        //   null,
        //   false
        // ).then(() => {
        //   navigate('/main');
        // });

        SaveAppointment(
          {
            idPatient: data?.idPatient,
            idNobat: data?.idNobat,
          },
          data?.navigate
        );
        sessionStorage.removeItem('saveTurn');
      } else {
        SwalAlert('error', response.data.resMessage, false);
      }
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }

    return response;
  });
};
